import React, { useState, useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import GridTable from "../../components/GridTable";
import useAuth from "../../hooks/useAuth";
import { getManagerAssignedAppraisalById } from "../../api/appraisalApi";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Button as MButton } from "@mui/material";
import { getStatusNameByValue, STATUS, statusOption } from "../../uitls/Utils";
import Dropdown from "../../components/Dropdown";
const ManagerAssignedAppraisal = () => {
  const { auth } = useAuth();
  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();
  const [selectedStatus, setSelectedStatus] = useState(null);
  const [filteredData, setFilteredData] = useState([]);
  const { managerAssignedAppraisalList } = useSelector(
    (state) => state.appraisalState
  );
  const navigate = useNavigate();
  const userId = auth?.user?.id;
  const currentPageStatus = searchParams.get("status");
  useEffect(() => {
    const status = currentPageStatus;
    dispatch(getManagerAssignedAppraisalById({ userId, status }));
  }, [dispatch, userId, currentPageStatus]);

  // Filter data based on status
  const statusFilteredData = useMemo(() => {
    if (!selectedStatus || !selectedStatus.value) {
      return managerAssignedAppraisalList;
    }
    return managerAssignedAppraisalList.filter(
      (item) => item.currentAppraisalStatus === selectedStatus.value
    );
  }, [managerAssignedAppraisalList, selectedStatus]);

  useEffect(() => {
    setFilteredData(statusFilteredData);
  }, [statusFilteredData]);

  const startSbumittion = (row, actionType) => {
    navigate(
      "/mgr/manage-manager-self-appraisal?id=" +
        row.id +
        "&action=" +
        actionType
    );
  };
  const showViewButton = (status) => {
    const {
      NOT_STARTED,
      UNDER_REVIEW,
      APPROVED,
      CHANGE_REQUEST,
      NEED_DISCUSSION,
      FINAL_REVIEWED,
      IN_PROGRESS,
    } = STATUS;

    if (auth.user?.managerId) {
      return status !== NOT_STARTED;
    } else {
      return [
        UNDER_REVIEW,
        CHANGE_REQUEST,
        NEED_DISCUSSION,
        FINAL_REVIEWED,
        APPROVED,
        IN_PROGRESS,
      ].includes(status);
    }
  };

  const showSubmitButton = (status) => {
    const { NOT_STARTED, COMPLETED } = STATUS;

    if (auth.user?.managerId) {
      return status === NOT_STARTED;
    } else {
      return status === COMPLETED && !auth.user?.managerId;
    }
  };

  const columns = [
    {
      field: "templateTitle",
      headerName: "Appraisal Name",
      width: 300,
      headerClassName: "super-app-theme--header",
      renderCell: (params) => (
        <span>{params.row.appraisalTemplate.templateTitle}</span>
      ),
    },

    {
      field: "employeeName",
      headerName: "Employee Name",
      width: 200,
      headerClassName: "super-app-theme--header",
      renderCell: (params) => (
        <span>
          {params.row.assignedUser?.firstName || "-"}{" "}
          {params.row.assignedUser?.lastName || "-"}
        </span>
      ),
    },
    {
      field: "currentAppraisalStatus",
      headerName: "Status",
      width: 200,
      headerClassName: "super-app-theme--header",
      renderCell: (params) => <span>{getStatusNameByValue(params.value)}</span>,
    },
    {
      field: "userSubmissionEndDate",
      headerName: "Last Submission Date",
      width: 200,
      headerClassName: "super-app-theme--header",
    },
    {
      field: "quickAction",
      headerName: "Quick Action",
      width: 200,
      headerClassName: "super-app-theme--header",
      // renderCell: (params) => (
      //   <div className="flex  justify-between">
      //     {/* {!auth.user?.managerId || !["COMPLETED","APPROVED","FINAL_REVIEWED"].includes(params?.row?.currentAppraisalStatus)&& */}
      //     <MButton
      //       variant="outlined"
      //       onClick={() => startSbumittion(params.row, "Submit")}
      //       className="mr-3"
      //     >
      //       Submit
      //     </MButton>
      //     {/* } */}
      //     <MButton
      //       variant="outlined"
      //       onClick={() => startSbumittion(params.row, "View")}
      //       className="mr-3"
      //     >
      //       View
      //     </MButton>
      //   </div>
      // ),
      renderCell: (params) => {
        const isManagerReview = params.row.currentAppraisalStatus === STATUS.COMPLETED;
        const buttonText = isManagerReview ? "Review Appraisal" : "Submit";
        
        return (
          <div className="flex  justify-between">
            {showSubmitButton(params.row.currentAppraisalStatus) && (
              <MButton
                variant="outlined"
                onClick={() => startSbumittion(params.row, "Submit")}
                className="mr-3"
              >
                {buttonText}
              </MButton>
            )}
            {showViewButton(params.row.currentAppraisalStatus) && (
              <MButton
                variant="outlined"
                onClick={() => startSbumittion(params.row, "View")}
                className="mr-3"
              >
                View
              </MButton>
            )}
          </div>
        );
      },
    },
  ];
  const handleStatusChange = (value) => {
    setSelectedStatus(value);
  };

  // Status filter component to be placed in GridTable header
  const statusFilterComponent = (
    <div className="w-full sm:w-auto min-w-[180px]">
      <Dropdown
        submitRef={true}
        defaultValue={selectedStatus}
        options={statusOption}
        handleChange={handleStatusChange}
        requiredField={false}
        defaultLabel="Filter by Status"
        label=""
        className="h-[48px] bg-white/95 backdrop-blur-md border-2 border-white/40 rounded-xl"
        isClearable={true}
      />
    </div>
  );

  return (
    <div className="pt-4 md:pt-6 2xl:pt-10 w-full px-4 md:px-6 lg:px-8">
      <GridTable
        rowData={filteredData}
        columnData={columns}
        toolTipName={"Create Self Appraisal"}
        hideSearchBar={false}
        statusFilter={statusFilterComponent}
      />
    </div>
  );
};

export default ManagerAssignedAppraisal;
